import { omit } from "lodash";

type AlgoliaHit = {
  readonly objectID: string;
  readonly _highlightResult?: {} | undefined;
  readonly _snippetResult?: {} | undefined;
  readonly _rankingInfo?: any;
  readonly _distinctSeqID?: number;
};

export const formatAlgoliaHits = <T>(hits: (AlgoliaHit & T)[]): T[] => {
  return hits.map(
    (hit) =>
      omit({ ...hit, id: hit.objectID }, [
        "objectID",
        "_highlightResult",
        "_snippetResult",
        "_rankingInfo",
        "_distinctSeqID",
      ]) as T,
  );
};
